import { createFileRoute } from '@tanstack/react-router'
import { LogoOnlyLayout } from 'merchant-components'

export const Route = createFileRoute('/(public)/login')({
  component: LogoOnlyLayout,
})
